/**
 * @description: 艺人上下钟明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ydm-report">
        <div class="ydm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-date">
                    <div ref="ydmTime">
                        <input type="text" class="form-control laydate-icon" v-model="ydmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ydmEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ydmShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢类型" ref="ydmBoxType"></select>
                </div>
                <label class="list-label-4">上钟包厢:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择上钟包厢" ref="ydmBox"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">区域:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择区域" ref="ydm_area"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="ydm_tit_sel">
                        <option value="stage_name">艺名</option>
                        <option value="waist_tag">腰牌号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="ydm_con_val" :placeholder="ydm_con_phd">
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ydm_charger" data-placeholder="请选择主管"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="ydm_group_txt" ref="ydm_group_txt" readonly @click="ydmEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">上钟类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ydm_type">
                        <option value=" ">全部</option>
                        <option value="-1">上钟</option>
                        <option value="1">串台</option>
                    </select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYdmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYdmExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ydmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ydmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ydmExport_allcheck' @click='ydmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="pson_stage_name">
                            <label>艺人姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="pson_waist_tag">
                            <label>腰牌号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="room_name">
                            <label>上钟包厢</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="room_area_name">
                            <label>区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="room_type_name">
                            <label>包厢类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="punch_in_time">
                            <label>上钟时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="punch_out_time">
                            <label>下钟时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="work_time">
                            <label>上钟时长</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ydmExport_checkModel' value="is_ct_name">
                            <label>上钟类型</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ydmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ydmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="ydm-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="ydm_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYdmGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='ydm_group_allcheck' @click='groupYdmCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in ydm_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='ydm_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ydmGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ydmGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ydmStartTime: "",
                ydmEndTime: "",
                ydm_field: "stage_name",
                ydm_con_phd: "请输入艺名",
                ydm_con_val: "",
                ydm_group_txt: "",
                ydm_group_allcheck: false,
                ydm_c_group_allcheck: false,
                ydm_group_checkboxModel: [],
                c_ydm_group_checkboxModel: [],
                ydm_group_checkboxData: [],
                ydm_group_name: '',
                ydmExport_allcheck: false,
                c_ydmExport_allcheck: false,
                ydmExport_checkModel: [],
                ydmExport_checkData: ['shop_name', 'group_name', 'director_name', 'pson_stage_name', 'pson_waist_tag', 'room_name', 'room_area_name', 'room_type_name', 'punch_in_time', 'punch_out_time', 'is_ct_name'],
                ydmExport_type: 1,
            }
        },
        watch: {
            ydm_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.ydm_group_checkboxModel.length >= this.ydm_group_checkboxData.length) {
                        this.ydm_group_allcheck = true;
                        this.ydm_c_group_allcheck = true;
                    } else {
                        this.ydm_group_allcheck = false;
                        this.ydm_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ydmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ydmExport_checkModel.length >= this.ydmExport_checkData.length) {
                        this.ydmExport_allcheck = true;
                        this.c_ydmExport_allcheck = true;
                    } else {
                        this.ydmExport_allcheck = false;
                        this.c_ydmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.ydmStartTime = moment().format('YYYY-MM-DD');
            _this.ydmEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
            _this.innitDate(); // 日期
            // 下拉选项
            $(_this.$refs.ydm_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.ydm_field = $(this).val();
                _this.ydm_con_val = '';
                if(_this.ydm_field == 'stage_name') {
                    _this.ydm_con_phd = '请输入艺名';
                } else if(_this.ydm_field == 'waist_tag') {
                    _this.ydm_con_phd = '请输入腰牌号';
                }
            });
            // 上钟类型
            $(_this.$refs.ydm_type).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
            _this.shopDatas = [];
            _this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ydmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                            this.ydmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                        }else {
                            this.ydmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                            this.ydmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ydmTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ydmStartTime = start.format('YYYY-MM-DD');
                    _this.ydmEndTime = end.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ydmShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.ydm_group_checkboxModel = [];
                                _this.ydm_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    // 包厢类型
                                    $(_this.$refs.ydmBoxType).val('').trigger('change');
                                    $(_this.$refs.ydmBoxType).prop('disabled', false);
                                    // 包厢号
                                    $(_this.$refs.ydmBox).val('').trigger('change');
                                    $(_this.$refs.ydmBox).prop('disabled', false);
                                    // 区域
                                    $(_this.$refs.ydm_area).val('').trigger('change');
                                    $(_this.$refs.ydm_area).prop('disabled', false);
                                    // 主管
                                    $(_this.$refs.ydm_charger).val('').trigger('change');
                                    $(_this.$refs.ydm_charger).prop("disabled", true);
                                    return;
                                }
                                // 包厢类型
                                $(_this.$refs.ydmBoxType).prop('disabled', false);
                                _this.getBoxType(e.params.data.id);
                                // 包厢号
                                $(_this.$refs.ydmBox).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                // 区域
                                $(_this.$refs.ydm_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                // 主管
                                $(_this.$refs.ydm_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ydmShop).val(data.response.result[1].id).trigger('change');
                            // 包厢类型
                            $(_this.$refs.ydmBoxType).prop('disabled', false);
                            _this.getBoxType(data.response.result[1].id);
                            // 包厢号
                            $(_this.$refs.ydmBox).prop('disabled', false);
                            _this.getRoomdata(data.response.result[1].id);
                            // 区域
                            $(_this.$refs.ydm_area).prop('disabled', false);
                            _this.getRoomArea(data.response.result[1].id);
                            // 主管
                            $(_this.$refs.ydm_charger).prop("disabled", false);
                            _this.getChargeData(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitYdmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢类型
            getBoxType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getRoomType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            // 初始化
                            $(_this.$refs.ydmBoxType).html('');
                            $(_this.$refs.ydmBoxType).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ydmBox).html("");
                            $(_this.$refs.ydmBox).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: ' ', text: '全部'}];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ydm_area).html("");
                            $(_this.$refs.ydm_area).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.ydm_charger).html('');
                            $(_this.$refs.ydm_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },



            // 进入选择组别
            ydmEnterGroup: function() {
                this.c_ydm_group_checkboxModel = this.ydm_group_checkboxModel;
                this.ydm_group_checkboxModel = [];
                this.getYdmGroupData();
                this.ydm_group_checkboxModel = this.c_ydm_group_checkboxModel;
                $('.ydm-list').hide();
                $('.ydm-group').show();
            },
            // 获取组别列表
            getYdmGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ydmShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.ydm_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ydm_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYdmCheckedAll: function() {
                let _this = this;
                _this.ydm_group_allcheck = _this.ydm_c_group_allcheck;
                if(!_this.ydm_group_allcheck) { // 实现全选
                    _this.ydm_group_checkboxModel = [];
                    _this.ydm_group_checkboxData.forEach(function(item) {
                        _this.ydm_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.ydm_group_checkboxModel = [];
                }
            },
            // 返回
            ydmGroupBack: function() {
                $('.ydm-group').hide();
                $('.ydm-list').show();
                this.ydm_group_checkboxModel = this.c_ydm_group_checkboxModel;
            },
            ydmGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.ydm_group_checkboxData.forEach(function(item) {
                    _this.ydm_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.ydm_group_txt = arr.join(',');
                $('.ydm-group').hide();
                $('.ydm-list').show();
            },
            // 表格
            innitYdmTable: function() {
                let _this = this;
                $(_this.$refs.ydmList).bootstrapTable('destroy');
                $(_this.$refs.ydmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYdmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "5%"
                    }, {
                        field: "director_name",
                        title: "主管",
                        width: "8%"
                    }, {
                        field: "pson_stage_name",
                        title: "艺人姓名",
                        width: "8%"
                    }, {
                        field: "pson_waist_tag",
                        title: "腰牌号",
                        width: "8%"
                    }, {
                        field: "room_name",
                        title: "上钟包厢",
                        width: "8%"
                    }, {
                        field: "room_area_name",
                        title: "区域",
                        width: "8%"
                    }, {
                        field: "room_type_name",
                        title: "包厢类型",
                        width: "8%"
                    }, {
                        field: "punch_in_time",
                        title: "上钟时间",
                        width: "8%"
                    }, {
                        field: "punch_out_time",
                        title: "下钟时间",
                        width: "8%"
                    }, {
                        field: "work_time",
                        title: "上钟时长",
                        width: "8%"
                    }, {
                        field: "is_ct_name",
                        title: "上钟类型",
                        width: "100"
                    }],
                });
            },
            // 数据
            getYdmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let stage_name = "",
                    waist_tag = "";
                if(_this.ydm_field == 'stage_name') {
                    stage_name = _this.ydm_con_val;
                } else if(_this.ydm_field == 'waist_tag') {
                    waist_tag = _this.ydm_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ydmStartTime,
                            "end_time": _this.ydmEndTime,
                            "shop_id": $(_this.$refs.ydmShop).val(),
                            "room_type": $.trim($(_this.$refs.ydmBoxType).val()),
                            "room_id": $.trim($(_this.$refs.ydmBox).val()),
                            "room_area": $.trim($(_this.$refs.ydm_area).val()),
                            "stage_name": stage_name,
                            "waist_tag": waist_tag,
                            "group_id": _this.ydm_group_checkboxModel,
                            "director_uid": $.trim($(_this.$refs.ydm_charger).val()),
                            "is_ct": $.trim($(_this.$refs.ydm_type).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPersonnelPunchDetailList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYdmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/personnelPunchDetailExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ydmExport_checkModel = data.response.result.export_fields;
                                _this.ydmExport_type = data.response.result.export_type;
                            } else {
                                _this.ydmExport_checkModel = _this.ydmExport_checkData;
                                _this.ydmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ydmExport_alert)
                }, function() {
                    _this.exportYdmList();
                });
            },
            // 导出字段全选
            ydmExportCheckedAll: function() {
                let _this = this;
                _this.ydmExport_allcheck = _this.c_ydmExport_allcheck;
                if(!_this.ydmExport_allcheck) { // 实现全选
                    _this.ydmExport_checkModel = [];
                    _this.ydmExport_checkData.forEach(function(item) {
                        _this.ydmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ydmExport_checkModel = [];
                }
            },
            // 导出
            exportYdmList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ydmExport_checkModel);
                let stage_name = "",
                    waist_tag = "";
                if(_this.ydm_field == 'stage_name') {
                    stage_name = _this.ydm_con_val;
                } else if(_this.ydm_field == 'waist_tag') {
                    waist_tag = _this.ydm_con_val;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/personnelPunchDetailExport?" +
                    "start_time=" + _this.ydmStartTime +
                    "&end_time=" + _this.ydmEndTime +
                    "&shop_id=" + $(_this.$refs.ydmShop).val() +
                    "&room_type=" + $.trim($(_this.$refs.ydmBoxType).val()) +
                    "&room_id=" + $.trim($(_this.$refs.ydmBox).val()) +
                    "&room_area=" + $.trim($(_this.$refs.ydm_area).val()) +
                    "&stage_name=" + stage_name +
                    "&waist_tag=" + waist_tag +
                    "&group_id=" + _this.ydm_group_checkboxModel +
                    "&director_uid=" + $.trim($(_this.$refs.ydm_charger).val()) +
                    "&is_ct=" + $.trim($(_this.$refs.ydm_type).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ydmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .ydm-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }

    .ydm-list {
        table {
            // table-layout: fixed;
            word-break: break-all;
        }
    }
</style>